export default "__VITE_ASSET__8fff5228__"